export default __webpack_public_path__ + "static/botw-traditional-quest-ab41e4a50396527104f63064ff7fbe8c.jpg";